module.exports = __webpack_public_path__ + "static/media/ic_home.f4433f2c.svg";